import { useDispatch, useSelector } from "react-redux";
import { onErr, onSub, selectForm } from "../../store/slices/contactFormSlice";
import axios from "axios";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";
const apiUrl = process.env.REACT_APP_API_URL;

const ContactForm = () => {
  const selectedLanguages = useSelector(selectedLanguage);
  const selectFormContact = useSelector(selectForm);
  const dispatch = useDispatch();

  const regex = /@(gmail\.com|gmail\.am|mail\.ru|mail\.am|mail\.com|bk\.ru|inbox\.ru|yahoo\.ru)$/;

  const seeValue = (ev) => {
    const txt = ev.target.value;
    if (regex.test(txt)) {
      dispatch(onSub(true));
      dispatch(onErr(false));
    } else {
      if (selectFormContact) {
        dispatch(onSub(false));
      }
      dispatch(onErr(true));
    }
  };

  const sendEmail = async (ev) => {
    ev.preventDefault();

    const {
      user_name: { value: user_name },
      user_email: { value: user_email },
      message: { value: message },
    } = ev.target;

    const formData = {
      name: user_name,
      email: user_email,
      message,
    };

    try {
      const response = await axios.post(`${apiUrl}/layout-form`, formData);
      if (response.data.success) {
        console.log("all good");
      } else {
        console.error("all bad")
      }
    } catch (error) {
      alert("please try later");
    }
    if (selectFormContact) {
      dispatch(onSub(false));
    }

    ev.target.reset();
  };

  return (
    <form onSubmit={sendEmail}>
      <div className="contact__form">
        <label htmlFor="name">
          {translations[selectedLanguages].contactForm.nameTitle}
          <span>*</span>
        </label>
        <input
          id="name"
          name="user_name"
          placeholder={translations[selectedLanguages].contactForm.namePlaceholder}
          required
          type="text"
          autoComplete="name"
        />
      </div>
      <div className="contact__form">
        <label htmlFor="email">
          {translations[selectedLanguages].contactForm.emailTitle}
          <span>*</span>
        </label>
        <input
          id="email"
          name="user_email"
          type="email"
          placeholder="WebsitePro@gmail.com"
          required
          autoComplete="email"
          onChange={seeValue}
        />
        {selectFormContact.err && <p>{translations[selectedLanguages].contactForm.wrongEmail}</p>}
      </div>
      <div className="contact__form">
        <label htmlFor="message">
          {translations[selectedLanguages].contactForm.messageTitle}
          <span>*</span>
        </label>
        <textarea
          name="message"
          id="message"
          placeholder={translations[selectedLanguages].contactForm.messagePlaceholder}
          rows={5}
          required
          defaultValue={""}
          autoComplete="off"
        />
      </div>
      {selectFormContact.btnForm ? (
        <button type="submit" className="activeBtn">
          {translations[selectedLanguages].contactForm.button}
        </button>
      ) : (
        <button type="button" className="passiveBtn">
          {translations[selectedLanguages].contactForm.button}
        </button>
      )}
    </form>
  );
};

export default ContactForm;
